// tslint:disable: completed-docs
import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import {toggleOverlay} from './action';
import { trackingBasedOnState } from './helper/trackingBasedOnState';
import {createStructuredSelector} from 'reselect';
import {RootState} from './types';

import {NAMESPACE, SET_TRACKING_STATE} from './constant';
import reducer from './reducer';
import overlaySaga from './saga';

import './style.scss';

import {
    selectRootOverlayNameState,
    selectRootOverlayState,
} from './selector';

import {
    trackOverlay,
} from './action';

interface StateProps {
    overlayState: boolean;
    overlayName: string;
}

import {
    mountOverlay,
} from './components/Overlay';

/**
 * Overlay function
 */
function overlay (state, actions) {

    injectReducer(NAMESPACE, reducer);
    injectSaga(NAMESPACE, overlaySaga);

    mountOverlay(actions.toggleOverlay);

    return {
        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState - You may also pass the oldState here, if needed
         */
        getDerivedStateFromProps (newState, oldState) {
            trackingBasedOnState(SET_TRACKING_STATE, newState, oldState, actions.trackOverlay);
        },
    };
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    overlayState: selectRootOverlayState(),
    overlayName: selectRootOverlayNameState(),
});

const mapDispatch = {
    toggleOverlay,
    trackOverlay,
};

const Overlay = connect(mapStateToProps, mapDispatch)(overlay);
export default Overlay;
